<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">

    <div class="md-layout-item md-elevation-0">   

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Información de Suscripción Inicial
        </md-card-header>
        <md-card-content>
        
            <p align="justify">
                Ante cualquier duda, comuníquese con su promotor.
            </p>
                    
        </md-card-content> 
      </md-card>

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('personanatutalinstitucional')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          ¿Es usted una persona natural institucional?
        </md-card-header>
        <md-card-content>
        
            <p align="justify">
                Inversionista Institucional: persona natural que cuenta con un patrimonio superior a S/. 4 millones y un portafolio de inversiones en valores igual o superior a S/. 2 millones.
            </p>
                    
            <div>
              <md-checkbox v-model="form.personanatutalinstitucional" :disabled="isDisabled" value="Si">Sí</md-checkbox>
              <md-checkbox v-model="form.personanatutalinstitucional" :disabled="isDisabled" value="No">No</md-checkbox>
            </div>       

            <div class="radioform" :class="getValidationClass('personanatutalinstitucional')">
              <span class="md-error" v-if="!$v.form.personanatutalinstitucional.required">Esta respuesta es obligatoria.</span>
            </div>

        </md-card-content> 
      </md-card>            

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>  

    </div>

  </form>
</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
// import { alpha } from '../variables'
import {
  required,
//   minLength,
//   numeric,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  name: 'Item10',
  data: () => ({
    form:{
    }
  }),
  props: ["title", "data", "isDisabled"],
  mounted: function(){
    this.form = this.$store.state.item.item10
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        personanatutalinstitucional: {required,},
      }        
    }
    return validate;
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item10
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {

        var index = "0";
        if(this.form.personanatutalinstitucional == "Si"){
          index = "12";
        }else{
          if(this.data.name == "Participe"){
            if(this.$store.state.item.item9.titularidad != "Individual"){
              index = "13";
            }else{
              index = "13";
            }
          }else{
            index = "13";
          }
        }
        this.$emit('setSaveForm', {id:"10", form: this.form, index: index});
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
